import React from "react";
import { motion } from "framer-motion";
import { MapPin, ArrowUpRight } from "lucide-react";
import { resolveImage } from "@/lib/api";

export const ProjectCard = ({ project, index = 0, onClick }) => {
  const img = resolveImage(project.image_paths?.[0]);
  return (
    <motion.button
      type="button"
      data-testid={`project-card-${project.id}`}
      onClick={onClick}
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 0.5, delay: (index % 3) * 0.1 }}
      className="group text-left relative overflow-hidden bg-navy w-full"
    >
      <div className="aspect-[4/3] overflow-hidden">
        {img ? (
          <img src={img} alt={project.title} className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-110" />
        ) : (
          <div className="h-full w-full bg-navy-light" />
        )}
      </div>
      <div className="absolute inset-0 bg-gradient-to-t from-navy via-navy/40 to-transparent opacity-90" />
      <div className="absolute top-4 left-4">
        <span className="bg-gold text-navy text-[11px] font-bold tracking-wide px-3 py-1 uppercase">{project.category}</span>
      </div>
      <div className="absolute bottom-0 inset-x-0 p-6 translate-y-2 group-hover:translate-y-0 transition-transform duration-300">
        <h3 className="font-display text-xl text-white leading-tight">{project.title}</h3>
        <div className="mt-2 flex items-center gap-2 text-white/70 text-sm">
          {project.location && (<><MapPin size={14} className="text-gold" /> {project.location}</>)}
          {project.year && <span className="ml-auto text-gold font-semibold">{project.year}</span>}
        </div>
        <div className="mt-3 flex items-center gap-1 text-gold text-sm font-semibold opacity-0 group-hover:opacity-100 transition-opacity">
          View Project <ArrowUpRight size={16} />
        </div>
      </div>
    </motion.button>
  );
};
